(() => {
  if (window.KaratiWhatsappTrackingInitialized) return;
  window.KaratiWhatsappTrackingInitialized = true;

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const link = target.closest('a');
    const destination = link?.href || '';
    const isWhatsappLink =
      destination.includes('wa.me') ||
      destination.includes('whatsapp') ||
      destination.includes('api.whatsapp');
    const isWhatsappElement =
      target.closest('[class*="whatsapp" i]') || target.closest('[id*="whatsapp" i]');

    if (!isWhatsappLink && !isWhatsappElement) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'click_whatsapp_gtm',
      url_destino: destination || 'Boton_Header_Karati',
    });
  });
})();
